<template>
  <div v-if="view.requestId || view.error" class="draw-recovery activity-record-panel" :aria-busy="view.loading">
    <h3>上次抽取结果</h3>
    <span v-if="view.requestId" class="activity-text receipt-number">请求编号：{{ view.requestId }}</span>
    <span class="activity-text" v-if="view.loading" role="status">正在查询原记录…</span>
    <span class="activity-text" v-if="view.waiting" role="status">射门或抽取仍在处理中，请等待结果后再核对。</span>
    <span v-if="view.error" class="activity-text recovery-error" role="alert">{{ view.error }}</span>
    <template v-if="view.result">
      <span class="activity-text">{{ view.result.status === 'COMPLETED' ? '原结果已确认' : '原记录待处理' }}</span>
      <span class="activity-text" v-if="view.result.targetTitle">原参与档位/关卡：{{ view.result.targetTitle }}</span>
      <span class="activity-text" v-if="view.result.rewardPoints > 0">原积分奖励：{{ view.result.rewardPoints }} 积分</span>
      <span class="activity-text" v-if="view.result.prizeName">原奖品：{{ view.result.prizeName }}</span>
      <span class="activity-text" v-if="positiveAmount(view.result.rewardAmount)">原奖励金额：{{ view.result.rewardAmount }} 元</span>
      <span class="activity-text" v-if="view.result.createdAt">抽取时间：{{ formatPrizeTime(view.result.createdAt) }}</span>
      <span class="activity-text" v-if="view.result.prizeId && !view.result.prizeOrderId">原奖品尚未关联申请订单，请联系客服核对</span>
      <ActivityAction v-if="view.result.prizeOrderId" variant="text" @click="openOrder">查看原申请订单</ActivityAction>
    </template>
    <ActivityAction variant="text" :loading="view.loading" @click="refresh">重新核对原结果</ActivityAction>
  </div>
</template>
<script setup>
import { onBeforeUnmount, ref, watch } from 'vue';
import { gameplayApi } from '../../services/activities/webAdapter.js';
import { useWebActivity } from '../../services/activities/webAdapter.js';
const appConfig = { siteCode: 'web' };
import { gameId, positiveAmount } from '../../services/activities/gameplay.mjs';
import { createGameplayRecovery } from '../../services/activities/gameplayRecovery.mjs';
const formatPrizeTime = value => value ? new Date(value * 1000).toLocaleString('zh-CN', { timeZone:'Asia/Shanghai', hour12:false }) : '—';
import ActivityAction from './ActivityAction.vue';
const { getAuth, getToken, storage, go: goTo } = useWebActivity();
const emit = defineEmits(['order', 'busy']);
const props = defineProps({ activityId: { type: [Number, String], required: true }, active: { type: Boolean, default: true }, pendingRequest: { type: String, default: '' } });
const view = ref({ requestId: '', result: null, loading: false, error: '' });
const identity = () => getAuth()?.memberId ? `${appConfig.siteCode || 'default'}:${getAuth().memberId}` : '';
const recovery = createGameplayRecovery({ recover: gameplayApi.recover, identity, token: getToken, storage: { get: key => storage.get(key) },
  withLock: typeof navigator !== 'undefined' && navigator.locks ? (key, work) => navigator.locks.request(key, { ifAvailable: true }, lock => work(Boolean(lock))) : undefined,
  changed: value => { view.value = value; } });
function refresh() { if (props.active && !view.value.loading) return recovery.open(props.activityId); }
function openOrder() {
  if (!props.active || !recovery.canView() || !gameId(view.value.result?.prizeOrderId)) return;
  emit('order', view.value.result.prizeOrderId);
}
watch(() => [props.activityId, props.active, props.pendingRequest], () => { recovery.pause(); void refresh(); }, { immediate: true });
function syncIdentity(event) { if (!event.key || event.key === 'kaiyun_web_token' || event.key.startsWith('kg_game_draw:v2:')) { recovery.pause(); void refresh(); } }
if (typeof window !== 'undefined') window.addEventListener('storage', syncIdentity);
onBeforeUnmount(() => { recovery.pause(); if (typeof window !== 'undefined') window.removeEventListener('storage', syncIdentity); });
</script>
<style scoped src="./activity-records.css"></style>
